import { Delete } from '@mui/icons-material';
import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
} from 'reactstrap';

const AddSubjectModal = ({ isOpen, toggleModal, addSubject }) => {
  const [subjectData, setSubjectData] = useState({
    subjectName: '',
    languages: [''], // Languages can be added dynamically
    primaryLanguage: '',
    topics: [''], // Topics can be added dynamically
    totalQuestions: 0,
    status: 0,
    type: 'Subject',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSubjectData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleArrayChange = (e, field) => {
    const {
      value,
      dataset: { index },
    } = e.target;
    const updatedArray = [...subjectData[field]];
    updatedArray[index] = value;
    setSubjectData({ ...subjectData, [field]: updatedArray });
  };

  const addNewField = (field) => {
    setSubjectData({
      ...subjectData,
      [field]: [...subjectData[field], ''],
    });
  };

  const removeField = (field, index) => {
    const updatedArray = subjectData[field].filter((_, i) => i !== index);
    setSubjectData({ ...subjectData, [field]: updatedArray });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation logic
    const { subjectName, languages, primaryLanguage, topics } = subjectData;

    if (
      !subjectName.trim() ||
      languages.some((lang) => !lang.trim()) ||
      !primaryLanguage.trim() ||
      topics.some((topic) => !topic.trim())
    ) {
      alert('All fields are required. Please fill them out before submitting.');
      return;
    }

    const subjectRecord = {
      languages: subjectData.languages.map((lang)=>{return lang?.toLowerCase()?.trim()}),
      name: subjectData.subjectName,
      primaryLanguages: subjectData.primaryLanguage?.toLowerCase()?.trim(),
      status: 0,
      topics: subjectData.topics.map((topic)=>{return topic?.trim()}),
      totalQuestions: subjectData.totalQuestions || 0,
      type: 'Subject',
      updatedAt: new Date().toLocaleString(),
    };

    addSubject(subjectRecord);
    toggleModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      size='lg'
      style={{ height: '10%' }}
    >
      <div
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          padding: '10px 15px',
          color: '#fff',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Add New Subject
        <button
          type='button'
          className='close'
          onClick={toggleModal}
          style={{
            color: '#fff',
            fontSize: '24px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
          }}
        >
          &times;
        </button>
      </div>

      <ModalBody
        style={{
          backgroundColor: 'rgb(39, 41, 61)', paddingTop: '20px', 
          height: '71.5vh',
          overflowY: 'auto' }}
      >
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '20px',
            }}
          >
            {/* Name Field */}
            <FormGroup>
              <label style={{ color: '#fff' }}>Name*</label>
              <Input
                type='text'
                name='subjectName'
                value={subjectData.subjectName}
                onChange={handleInputChange}
                placeholder='Enter subject name'
                required
                style={{
                  backgroundColor: '#2c2f47',
                  color: '#fff',
                  border: '1px solid #5a5e75',
                }}
              />
            </FormGroup>

            {/* Topics Field */}
            <FormGroup>
              <label style={{ color: '#fff' }}>Topics*</label>
              {subjectData.topics.map((topic, index) => (
                <div
                  key={index}
                  style={{ display: 'flex', marginBottom: '10px' }}
                >
                  <Input
                    type='text'
                    value={topic}
                    className={subjectData.primaryLanguage == 'fganh' || subjectData.primaryLanguage == 'हिंदी' ? 'hinditext':''}
                    data-index={index}
                    onChange={(e) => handleArrayChange(e, 'topics')}
                    placeholder={`Enter topic ${index + 1}`}
                    style={{
                      backgroundColor: '#2c2f47',
                      color: '#fff',
                      border: '1px solid #5a5e75',
                      marginRight: '10px',
                    }}
                  />
                  <Delete
                    key={`deleteKey-${index}`}
                    style={{
                      color: 'red',
                      cursor: 'pointer',
                      height: '35px',
                    }}
                    onClick={() => removeField('topics', index)}
                  />
                </div>
              ))}
              <Button
                color='info'
                onClick={() => addNewField('topics')}
                style={{ marginBottom: '10px' }}
              >
                Add Topic
              </Button>
            </FormGroup>

            {/* Languages Field */}
            <FormGroup>
              <label style={{ color: '#fff' }}>Languages*</label>
              {subjectData.languages.map((language, index) => (
                <div
                  key={index}
                  style={{ display: 'flex', marginBottom: '10px' }}
                >
                  <Input
                    type='text'
                    value={language}
                    data-index={index}
                    onChange={(e) => handleArrayChange(e, 'languages')}
                    placeholder={`Enter language ${index + 1}`}
                    style={{
                      backgroundColor: '#2c2f47',
                      color: '#fff',
                      border: '1px solid #5a5e75',
                      marginRight: '10px',
                    }}
                  />
                  <Delete
                    key={`deleteKey-${index}`}
                    style={{
                      color: 'red',
                      cursor: 'pointer',
                      height: '35px',
                    }}
                    onClick={() => removeField('languages', index)}
                  />
                </div>
              ))}
              <Button
                color='info'
                onClick={() => addNewField('languages')}
                style={{ marginBottom: '10px' }}
              >
                Add Language
              </Button>
            </FormGroup>

            {/* Primary Language Dropdown */}
            {subjectData.languages.some((lang) => lang.trim()) && (
              <FormGroup>
                <label style={{ color: '#fff' }}>Primary Language*</label>
                <Input
                  type='select'
                  name='primaryLanguage'
                  value={subjectData.primaryLanguage}
                  onChange={handleInputChange}
                  style={{
                    backgroundColor: 'rgb(44, 47, 71)',
                    color: 'rgb(255, 255, 255)',
                    border: '1px solid rgb(90, 94, 117)',
                    height: '37px',
                    width: '365px',
                    borderRadius: '5px',
                    marginTop: '-76px', // Adjust margin-top as per requirement
                  }}
                  required
                >
                  <option value='' disabled>
                    Select Primary Language
                  </option>
                  {subjectData.languages.map(
                    (language, index) =>
                      language.trim() && (
                        <option key={index} value={language}>
                          {language}
                        </option>
                      )
                  )}
                </Input>
              </FormGroup>
            )}
          </div>
        </form>
      </ModalBody>

      <ModalFooter
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          display: 'flex',
          justifyContent: 'end',
          paddingTop: '12px',
          gap: '12px',
        }}
      >
        <Button
          color='info'
          onClick={handleSubmit}
          style={{
            backgroundColor: '#1d91c9',
            borderColor: '#1d91c9',
            padding: '8px 20px',
            marginRight: '10px',
            borderRadius: '5px',
          }}
        >
          Add Subject
        </Button>
        <Button
          color='secondary'
          onClick={toggleModal}
          style={{
            borderRadius: '5px',
            padding: '8px 20px',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddSubjectModal;
